import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Box, Typography, Alert, Chip } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import apiClient from '../api/client';

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

const STATUS_COLORS = { available: 'success', pending: 'warning', sold: 'error' };
const US_CENTER = [39.5, -98.35];

const MapView = () => {
  const [properties, setProperties] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiClient.get('/properties')
      .then(res => setProperties(res.data.data))
      .catch(err => setError(err.message));
  }, []);

  const mapped = properties.filter(p => p.latitude != null && p.longitude != null);
  const center = mapped.length > 0 ? [mapped[0].latitude, mapped[0].longitude] : US_CENTER;
  const zoom = mapped.length > 0 ? 12 : 4;

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Map View</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {mapped.length === 0 && !error && (
        <Alert severity="info" sx={{ mb: 2 }}>
          No properties with coordinates yet. Add properties with latitude/longitude to see them here.
        </Alert>
      )}
      <MapContainer center={center} zoom={zoom} style={{ height: '70vh', borderRadius: 8 }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {mapped.map(p => (
          <Marker key={p.id} position={[Number(p.latitude), Number(p.longitude)]}>
            <Popup>
              <strong>{p.address}</strong><br />
              {p.city}, {p.state}<br />
              <span style={{ textTransform: 'capitalize' }}>{p.property_type}</span>
              {p.bedrooms != null && <> &middot; {p.bedrooms}bd/{p.bathrooms}ba</>}<br />
              {p.price && <>${Number(p.price).toLocaleString()}<br /></>}
              <Chip label={p.status} color={STATUS_COLORS[p.status]} size="small" sx={{ mt: 0.5 }} />
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
};

export default MapView;
